module.exports = __webpack_public_path__ + "static/media/close.efbf2170.svg";